import { Toaster } from 'components/notification/Toaster';
import usePromiseInstance_authorization from 'dataflow/billingPortal/actions/config';
import { func_serviceHandling, func_validation, getTotalCountFromHeader, isObjectNotEmpty } from 'functions';
import { useState } from 'react';
import { useDispatch, connect } from 'react-redux';


export function useTableData(props) {
    const [data, setData] = useState();
	const [isDataLoading, setIsDataLoading] = useState();
	const [totalRecords, setTotalRecords] = useState();
    const request = usePromiseInstance_authorization();

    function getData(pageNo, pageSize, sort, filterOptions = {}) {
        let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
			role: "Internal",
			...filterOptions
		}

		let url = func_serviceHandling.createUrlWithParams('/General/GetActivityLog', paramObj)

		setIsDataLoading(true);

        request({}, (axios) => {
			axios.get(url)
				.then(function (response) {
					// handle success
					setTotalRecords(getTotalCountFromHeader(response?.headers))
					let data = response?.data;
					if (data) setData(data);
				})
				.catch(function (response) {
					// handle error
					if (response?.data?.exceptionMessage) {
						Toaster({
							type: "error",
							msg: response?.data?.exceptionMessage
						})
					}
				})
				.finally(function () {
					// always executed
					setIsDataLoading(false);
				});
		})
    }

    return {
        getData,
        data, totalRecords,
		isDataLoading
    }
}